var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFieldConditionsField = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 17.3586,
    height: 18.1084,
    viewBox: "0 0 17.3586 18.1084",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fields Thumbnail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Field 08",
    d: "M7.93812 0.142366L0.146612 4.26486L7.97934 17.9927L17.1905 16.6342L7.93812 0.142366Z",
    fill: "#C2C7D0",
    strokeWidth: 0.212454,
    stroke: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFieldConditionsField);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/field-conditions-field.67da8d3c649dbccef014df725a15f90e.svg";